import * as React from "react";
import { callApi } from "../../utils/api";
import { ADMIN_ROLE } from "../../utils/role";
import ReactFlexyTable from "react-flexy-table";
import "react-flexy-table/dist/index.css";
import { ToastsContainer, ToastsContainerPosition, ToastsStore } from "react-toasts";
import Select from 'react-select';
import moment from "moment";
import { isEmpty } from "lodash";
import ReactFileReader from "react-file-reader";
import { MdOutlineUploadFile } from "react-icons/md";
import { FaEye } from "react-icons/fa6";
import { Modal } from "antd";
import { hasPageAccess } from "../../utils/pagePermissionService";

declare var $: any;
export interface Bank {
    id: number;
    name: string;
}
interface AllProps {
    history: any;
}
interface File {
    s3fileName: string;
    fileContent: string;
    fileName: string;
}

class SampleFormatManagement extends React.Component<AllProps> {
    state = {
        bankList: [],
        products: [],
        branches: [],
        bankproducts: [],
        productToBeDeleted: "",
        isFileRefresh: false,
        selectedproduct: {
            id: 0,
            bank_id: "",
            temp_id: "",
            product_id: "",
            selectedproduct_id: "",
            lawhands_branch: "",
        },
        outreason: "",
        selectVal: false,
        isLoading: false,
        required: false,
        filteredBranches: [],
        filteredProduct: [],
        bank_templates: [],
        files: [] as File[],
        docToPreview: "",
        lawhandsBranches: [],
    };
    async componentDidMount() {
        this.listBank();
        this.getBankList();
        this.listproduct();
        this.getOutTime();
        const hasHide = await hasPageAccess("In-Reason/Out-Reason Hide");
        if (!hasHide) {
            this.ouTime();
        }
        this.getLawHandsBranches();
        // this.listBranch();
        this.getTemplates();
    }
    getLawHandsBranches() {
        callApi("GET", "get_branch.php")
            .then(res => res.data)
            .then(response => {
                this.setState({ lawhandsBranches: response.data });
            })
            .catch(err => {
                console.log(err);
            });
    }
    getTemplates = () => {
        callApi("POST", "bank_temp_get.php")
            .then((res) => res.data)
            .then((response) => {
                let banks = response.data;
                // const vetting = banks.filter(
                //     (item) => item.name.split(" ").pop() != "Vetting"
                // );
                this.setState({ bank_templates: banks });
            })
            .catch((err) => {
                console.log(err);
            });
    };
    getBankList = () => {
        callApi("GET", "bank_get.php")
            .then(res => res.data)
            .then(response => {
                const bankList = response.data;
                this.setState({ bankList, isBankListLoaded: true });
            })
            .catch(err => {
                console.log(err);
            });
    };
    listproduct = () => {
        this.setState({ isFileRefresh: false });
        callApi("GET", "bank_product_get.php")
            .then(res => res.data)
            .then(response => {
                const files = response.data;
                this.setState({ products: files, isFileRefresh: true });
            })
            .catch(err => {
                console.log(err);
            });
    };
    listBranch = () => {
        callApi("GET", "bank_branch_get.php")
            .then(res => res.data)
            .then(response => {
                this.setState({ branches: response.data, filteredBranches: [] });
            })
            .catch(err => {
                console.log(err);
            });
    };
    listBank = () => {
        this.setState({ isFileRefresh: false });
        callApi("GET", "bank_template_select.php")
            .then(res => res.data)
            .then(response => {
                const files = response.data;
                if (files && files.length > 0) {
                    files.forEach((file, index) => {
                        Object.keys(file).forEach((fileKey: any) => {
                            // Skip the 'files' key from string conversion
                            if (fileKey !== 'files' && fileKey != 'lawhands_branch') {
                                file[fileKey] = !file[fileKey] ? "" : typeof file[fileKey] !== 'string' ? String(file[fileKey]) : file[fileKey];
                            }
                        });
                        file.index = index + 1;
                    });
                }
                this.setState({ bankproducts: files, isFileRefresh: true }, () => { });
            })
            .catch(err => {
                console.log(err);
            });
    };
    addBank = () => {
        this.setState({
            selectedproduct: {
                id: '',
                bank_id: '',
                temp_id: '',
                product_id: '',
                selectedproduct_id: '',
                lawhands_branch: '',
            },
            filteredProduct: [],
            filteredBranches: [],
            files: [],
            required: false,
        });
    };
    editBank = (bank: any) => {
        this.setState({ files: bank?.files });
        this.setState({ selectedproduct: bank }, () => {
            this.filterProduct(bank.bank_id);
            // this.filterBranchesproduct(bank.selectedproduct_id);
        });
    };
    saveBank = () => {
        const user: any = localStorage.getItem("user");
        const userId = user ? JSON.parse(user)["userId"] : "";
        const selectedproduct = this.state.selectedproduct;
        if (isEmpty(selectedproduct.bank_id) || isEmpty(selectedproduct.product_id) || isEmpty(selectedproduct.temp_id)) {
            ToastsStore.error("Please fill all the fields");
            this.setState({ required: true });
            return;
        }
        let req = {
            userid: userId,
            ...this.state.selectedproduct,
            // files: this.state.files,
            s3fileName: this.state?.files?.[0]?.s3fileName ?? '',
        }
        if (this.state.selectedproduct.id) {
            this.setState({ required: false });
            this.state.selectedproduct.id = Number(this.state.selectedproduct.id);
            callApi("POST", "bank_template_update.php", req)
                .then(res => res.data)
                .then(response => {
                    if (response.status == true) {
                        $("#product-form").modal("hide");
                        this.closeModal();
                        ToastsStore.success(response.message);
                        this.listBank();
                    } else {
                        // this.setState({ selectedproduct: {} })
                        ToastsStore.error(response.message);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        } else {
            this.setState({ required: false });
            callApi("POST", "bank_template_insert.php", req)
                .then(res => res.data)
                .then(response => {
                    if (response.status == true) {
                        $("#product-form").modal("hide");
                        this.closeModal();
                        ToastsStore.success(response.message);
                        this.listBank();
                    } else {
                        // this.setState({ selectedproduct: {} });
                        ToastsStore.error(response.message);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        }
    };

    closeModal = () => {
        this.setState({
            selectedproduct: {
                bank_id: '',
                product_id: '',
                temp_id: '',
                selectedproduct_id: '',
                lawhands_branch: '',
                files: [],
            },
            files: [],
            required: false,
        });
    };


    confirmDeleteBank = (modal: Bank) => {
        this.setState({ productToBeDeleted: modal.id });
    };
    deleteBank = () => {
        callApi("POST", "bank_template_delete.php", { id: this.state.productToBeDeleted })
            .then(res => res.data)
            .then(response => {
                $("#delete-bank").modal("hide");
                const msg = response && response.message;
                // bank_template_delete.php returns {message:"Deleted Successfully"} on success
                // and {message:"Not Delted"} on failure (no status/success field), so treat the
                // response as success unless it carries an explicit failure signal.
                const failed =
                    (response && (response.status === false || response.success === false)) ||
                    (typeof msg === "string" && /not\s*del/i.test(msg));
                if (!failed) {
                    this.listBank();
                    ToastsStore.success(msg || "Sample Format deleted successfully");
                } else {
                    ToastsStore.error(msg || "Failed to delete Sample Format");
                }
            })
            .catch(err => {
                console.log(err);
                $("#delete-bank").modal("hide");
                ToastsStore.error("An error occurred while deleting the Sample Format.");
            });
    };
    handleChange = (e: any) => {
        const selectedproduct: any = this.state.selectedproduct;
        selectedproduct[e.target.name] = e.target.value;
        this.setState({ selectedproduct });
    };
    filterProduct = (bankid: any) => {
        if (bankid) {
            const filteredProduct = this.state.products.filter(
                (branch: any) => branch.bank_id === bankid
            );
            const state: any = this.state;
            state.filteredProduct = filteredProduct;
            this.setState({ ...state });
        } else {
            this.setState({ product_id: "" })
        }
    };
    filterBranchesproduct = productid => {
        const filteredBranches = this.state.branches.filter((branch: any) => {
            return branch.product_id == productid && branch.bank_id == this.state.selectedproduct.bank_id;
        });
        const state: any = this.state;
        state.filteredBranches = filteredBranches;
        if (filteredBranches.length == 0) {
            state.temp_id = "";
        }
        this.setState({ ...state });
    };
    handleChangeselect = (e, propName?, fieldType?) => {
        if (fieldType === 'multiselect') {
            if (!e || e.length === 0) {
                const selectedproduct: any = this.state.selectedproduct;
                selectedproduct[propName] = [];
                this.setState({ selectedproduct });
                return;
            }

            // Check if "Select All" was clicked
            const isSelectAll = e.some((opt: any) => opt.value === 'ALL');

            let values;
            if (isSelectAll) {
                // Select ALL actual branch values
                values = this.state.lawhandsBranches.map((opt: any) => opt.value);
            } else {
                // Normal selection
                values = e.map((opt: any) => opt.value);
            }

            const selectedproduct: any = this.state.selectedproduct;
            selectedproduct[propName] = values;
            this.setState({ selectedproduct });
            return;
        }
        let fieldName = fieldType === 'singleselect' ? propName : e.target.name;
        let fieldValue = fieldType === 'singleselect' ? e.value : e.target.value;
        if (fieldName === "bank_id") {
            const state: any = this.state;
            state.filteredProduct = [];
            state.filteredBranches = [];
            const selectedproduct: any = this.state.selectedproduct;
            selectedproduct[fieldName] = fieldValue;
            selectedproduct.product_id = '';
            selectedproduct.temp_id = '';
            this.setState({ ...state, selectedproduct }, () => {
                this.filterProduct(fieldValue);
            });
        }
        if (fieldName === "product_id") {
            let newProductId = e.product_id;
            const state: any = this.state;
            state.filteredBranches = [];
            const selectedproduct: any = this.state.selectedproduct;
            selectedproduct.selectedproduct_id = fieldValue;
            selectedproduct.temp_id = '';
            selectedproduct[fieldName] = newProductId;
            // this.setState({ ...state, selectedproduct }, () => {
            //     this.filterBranchesproduct(fieldValue);
            // });
        }
        if (fieldName === "temp_id") {
            const selectedproduct: any = this.state.selectedproduct;
            selectedproduct[fieldName] = fieldValue
            this.setState({ selectedproduct });
        }
    };
    handleFiles = (files: any) => {
        this.setState({ files: [] });
        let baseFile: any = this.state.files || [];
        const fileSize = [...files.fileList].reduce((a, b) => +a + +b.size, 0);
        if (Number(fileSize) > 26214400) {
            ToastsStore.error("File(s) size shouldn't exceed 25 MB");
        } else {
            callApi("POST", "samp_temp_upload_s3.php", {
                base: files.base64,
            })
                .then((res) => {
                    if (res.data && res.data.file) {
                        baseFile.push({ fileContent: files.base64, fileName: files.fileList[0].name, s3fileName: res.data.file_name });
                        this.setState({ files: [...baseFile] });
                    } else {
                        ToastsStore.error("Failed to upload file(s)");
                    }
                })
                .catch((err) => {
                    ToastsStore.error("Failed to upload file(s)");
                });
        }
    }
    previewDoc = (url) => {
        this.setState({ docToPreview: url })
    };
    deleteDoc = (i) => {
        let { files } = this.state;
        files = files.filter((file, index) => index !== i);
        this.setState({ files });
    };
    previousPop = () => {
        $("#out_reason").modal("show");
        $("#another-reason").modal("hide");
    }
    BacktoFile = () => {
        $("#out_reason").modal("hide");
        const fileid1: any = localStorage.getItem("currentfileId");

        this.props.history.push("/file-dashboard/" + JSON.parse(fileid1));
    }
    getOutTime = () => {
        let date = new Date();
        let stratTime = date.getTime();
        localStorage.setItem("startTime", JSON.stringify(stratTime))
        let outDate = date.toLocaleDateString();
        localStorage.setItem("OutDateGet", JSON.stringify(outDate));
        var Railway = date.getMinutes();
        if (Railway < 10) {
            var TotalMinutes = "0" + Railway;
            let ouTtime = date.getHours() + ":" + TotalMinutes;
            localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
        }
        else {
            let ouTtime: any = date.getHours() + ":" + date.getMinutes();
            localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
        }

    }
    ouTime = () => {
        const getfileId: any = localStorage.getItem("currentfileId");
        if (localStorage.getItem("currentfileId")) {
            $("#out_reason").modal("show");
        }
    }
    outimeGet = () => {
        this.setState({ isLoading: true });
        const fileid1: any = localStorage.getItem("currentfileId");
        const userid1: any = localStorage.getItem("user1");
        const inreason: any = localStorage.getItem("in_reason");
        const intime: any = localStorage.getItem("IntimeGet");
        const outtime: any = localStorage.getItem("outtimeGet");
        const outdate: any = localStorage.getItem("OutDateGet");
        const secondsSpent = moment(outtime, "HH:mm").diff(moment(intime, "HH:mm"), 'seconds');
        const insertId: any = localStorage.getItem("ProcessEodInsertID");
        if (this.state.outreason == "") {
            this.setState({ selectVal: true });
        }
        else {
            let obj = {
                "file_id": JSON.parse(fileid1),
                "user_id": JSON.parse(userid1),
                "in_reason": JSON.parse(inreason),
                "out_reason": this.state.outreason,
                "intime": JSON.parse(intime),
                "outtime": JSON.parse(outtime),
                "insert_date": JSON.parse(outdate),
                "total_seconds": secondsSpent,
                "insert_id": insertId
            }
            callApi("POST", "process_eod_insert.php", obj)
                .then(res => res.data)
                .then(response => {
                    this.setState({ isLoading: false });
                    // localStorage.removeItem("currentfileId");
                    localStorage.removeItem("in_reason");
                    localStorage.removeItem("outreason");
                    localStorage.removeItem("IntimeGet");
                    localStorage.removeItem("OutDateGet");
                    $("#out_reason").modal("hide");
                    $("#another-reason").modal("hide");
                    ToastsStore.success("Your Reason Saved Successfully");
                    let process_officerId: any = localStorage.getItem("process_office_id");
                    let process_officer_id = JSON.parse(process_officerId);
                    const userid1: any = localStorage.getItem("user1");
                    let user_id = JSON.parse(userid1);
                    const take_file: any = localStorage.getItem("takenfile_id");
                    const user: any = localStorage.getItem("user");
                    const getfileId: any = localStorage.getItem("currentfileId");
                    if (process_officer_id == user_id && take_file != "" && take_file == getfileId) {
                        this.fileout(fileid1);
                    }
                }).catch((err) => {
                    console.log(err);
                    this.setState({ isLoading: false });
                    ToastsStore.error("Your Reason Not Stored");
                })
        }
    }
    fileout = (fileid1) => {
        let fileId = JSON.parse(fileid1);
        const loginuser: any = localStorage.getItem("user1");
        let req = {
            id: fileId,
            reason: "File Out",
            created_by: JSON.parse(loginuser)
        }
        callApi("POST", "time_update.php", req)
            .then(res => res.data)
            .then(response => {
                localStorage.removeItem('currentfileId');
                // localStorage.removeItem("takenfile_id");
            });
    }
    onchangeReason = (e: any) => {

        if (e.target.value == "Other") {
            this.setState({ in_reason: "", selectVal: false })
            $("#out_reason").modal("hide");
            $("#another-reason").modal("show");
        }
        else if (e.target.value == "select") {
            this.setState({ setResponse: false })
        }
        else {
            // this.setState({})
            this.setState({ [e.target.name]: e.target.value, selectVal: false });
        }
    };

    onchange = (e: any) => {
        this.setState({ [e.target.name]: e.target.value.replace(/\s+/g, ' ').trim(), selectVal: false });
    };

    handlePostRequired = (event, file) => {
        const checkedStatus = event.target.checked ? '1' : '0';
        let confirmLoading = false;

        const modal = Modal.confirm({
            title: `Are you sure you want to ${checkedStatus == '1' ? "enable" : 'disable'} status?`,
            content: "This action will update the post disbursement required.",
            okText: "Yes, Save",
            cancelText: "No, Cancel",
            okButtonProps: {
                loading: confirmLoading,
            },
            onOk: () =>
                new Promise<void>((resolve, reject) => {
                    confirmLoading = true;
                    modal.update({
                        okButtonProps: {
                            loading: confirmLoading,
                        },
                    });

                    callApi("POST", "post_required_status_update.php", { id: file.id, required_status: checkedStatus })
                        .then((res) => res.data)
                        .then((response) => {
                            confirmLoading = false;
                            modal.update({
                                okButtonProps: {
                                    loading: confirmLoading,
                                },
                            });

                            if (response.success) {
                                this.listBank();
                                ToastsStore.success(response.message);
                                resolve(); // Close the modal
                            } else {
                                ToastsStore.error(response.message);
                                reject(new Error(response.message)); // Keep the modal open
                            }
                        })
                        .catch((err) => {
                            confirmLoading = false;
                            modal.update({
                                okButtonProps: {
                                    loading: confirmLoading,
                                },
                            });

                            console.error(err);
                            ToastsStore.error("An error occurred while saving changes.");
                            reject(err); // Keep the modal open
                        });
                }),
            onCancel: () => {
                console.log("User canceled the action");
            },
        });
    };

    render() {
        const user: any = localStorage.getItem("user");
        const role_id = user ? JSON.parse(user)["role_id"] : "";
        const columns = [
            {
                header: 'ID',
                key: 'index',
            },
            {
                header: 'Bank Name',
                key: 'bank_name',
            },
            {
                header: 'Product Name',
                key: 'product_name',
            },
            {
                header: 'LH Branch Name',
                key: 'lawhands_branch_name',
            },
            {
                header: 'Template',
                key: 'temp_name',
            },
            {
                header: "Sample Pdf",
                td: (file) => {
                    return <div className="btn-group mb-2 mr-2">
                        <button
                            style={{ border: 'none' }}
                            // type="button"
                            // className="btn btn-primary"
                            data-toggle="modal"
                            data-target="#preview-document"
                            onClick={() =>
                                this.previewDoc(file.fileContent)
                            }
                        >
                            <FaEye color="black" style={{ height: "20", width: "20px" }} />
                        </button>
                    </div>
                }
            },
            {
                header: 'Post Disbursement (Required)',
                key: 'required_status',
                td: (file) => (
                    <label className="switch" style={{ marginLeft: "10%" }}>
                        <input
                            type="checkbox"
                            checked={file.required_status === '1'}
                            onChange={(event) => this.handlePostRequired(event, file)}
                        />
                        <span className="slider round"></span>
                    </label>
                )
            },
            {
                header: "Actions",
                td: (file) => {
                    return <div className="btn-group mb-2 mr-2">
                        <button
                            type="button"
                            className="btn btn-primary"
                        >
                            Action
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary dropdown-toggle dropdown-toggle-split"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <span className="sr-only">
                                Toggle Dropdown
                            </span>
                        </button>
                        <div
                            className="dropdown-menu"
                            x-placement="top-start"
                            style={{
                                position: "absolute",
                                top: "0px",
                                left: "0px",
                                transform:
                                    "translate3d(88px, -2px, 0px)"
                            }}
                        >
                            <a
                                className="dropdown-item"
                                data-toggle="modal"
                                data-target="#product-form"
                                onClick={() =>
                                    this.editBank(file)
                                }
                            >
                                Edit
                            </a>
                            {role_id === ADMIN_ROLE && (
                                <a
                                    className="dropdown-item"
                                    style={{ float: "right" }}
                                    data-toggle="modal"
                                    data-target="#delete-bank"
                                    onClick={() =>
                                        this.confirmDeleteBank(file)
                                    }
                                >
                                    Delete
                                </a>
                            )}
                        </div>
                    </div>
                }
            }
        ];
        const data = this.state.bankproducts;
        return (
            <section className="pcoded-main-container">
                <ToastsContainer
                    store={ToastsStore}
                    position={ToastsContainerPosition.TOP_RIGHT}
                />{" "}
                <div className="pcoded-wrapper">
                    <div className="pcoded-content">
                        <div className="pcoded-inner-content">
                            <div className="main-body">
                                <div className="page-wrapper">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card">
                                                <div className="card-header">
                                                    <h5>Sample Format Management</h5>
                                                    <button
                                                        className="btn btn-primary"
                                                        style={{ float: "right" }}
                                                        onClick={() => this.props.history.goBack()}
                                                    >
                                                        Back
                                                    </button>
                                                </div>
                                                <div className="card-body">
                                                    <div className="dt-responsive table-responsive">
                                                        <a
                                                            className="btn btn-primary m-b-20"
                                                            data-toggle="modal"
                                                            data-target="#product-form"
                                                            onClick={this.addBank}
                                                        >
                                                            + Add
                                                        </a>

                                                        {this.state.isFileRefresh && data && data.length > 0 &&
                                                            <ReactFlexyTable data={data} columns={columns} sortable globalSearch />
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="modal fade"
                    id="product-form"
                    role="dialog"
                    aria-hidden="true"
                >
                    <div className="modal-dialog" role="document"
                        style={{ maxWidth: "800px", maxHeight: "660px", overflow: "scroll" }}
                    >
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{this.state.selectedproduct.id ? "Edit" : "Add"}</h5>
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    onClick={this.closeModal}
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <form>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="col-form-label">Bank:<span style={{ color: "red" }}>*</span></label>{" "}
                                                {this.state.bankList && this.state.bankList.length > 0 && this.state.bankList.map((opt: any) => {
                                                    opt.label = opt.name; opt.value = opt.id
                                                }) &&
                                                    <Select className="form-select"
                                                        // options={[{ label: "Select...", value: "" }, this.state.bankList]}
                                                        options={[{ label: "Select...", value: "" },
                                                        ...this.state.bankList.map((b: any) => ({
                                                            label: b.name,
                                                            value: b.id
                                                        }))
                                                        ]}
                                                        name="bank_id"
                                                        value={this.state.bankList.find((o: any) => o.value == this.state.selectedproduct.bank_id)}
                                                        onChange={(e) => this.handleChangeselect(e, 'bank_id', 'singleselect')}
                                                    />
                                                }
                                                {this.state.selectedproduct.bank_id == "" && this.state.required == true && <div className="pt-1" style={{ fontSize: "11px", color: "#dc3545" }}>*Required Field</div>}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="col-form-label">Product:<span style={{ color: "red" }}>*</span></label>{" "}
                                                {this.state.filteredProduct && this.state.filteredProduct.map((opt: any) => {
                                                    opt.label = opt.product_name; opt.value = opt.id
                                                }) &&
                                                    <Select className="form-select" options={[{ label: "Select...", value: "" }, ...this.state.filteredProduct]} name="product_id"
                                                        value={this.state.filteredProduct.find((o: any) => o.product_id == this.state.selectedproduct.product_id)}
                                                        onChange={(e) => this.handleChangeselect(e, 'product_id', 'singleselect')}
                                                    />
                                                }
                                                {this.state.selectedproduct.product_id == "" && this.state.required == true && <div className="pt-1" style={{ fontSize: "11px", color: "#dc3545" }}>*Required Field</div>}
                                            </div>
                                        </div>


                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="col-form-label">Lawhands Branch</label>
                                                {this.state.lawhandsBranches && this.state.lawhandsBranches.length > 0 && this.state.lawhandsBranches.map((opt: any) => {
                                                    opt.label = opt.name; opt.value = opt.id
                                                }) &&
                                                    <Select isMulti closeMenuOnSelect={false} options={[{ label: "Select All", value: "ALL" }, ...this.state.lawhandsBranches]} name="lawhands_branch" className={this.state.required && this.state.selectedproduct.lawhands_branch === '' ? 'form-select is-invalid' : 'form-select'}
                                                        // value={this.state.lawhandsBranches.find((o: any) => o.value === this.state.selectedproduct.lawhands_branch)}
                                                        value={this.state.lawhandsBranches.filter((o: any) =>
                                                            this.state.selectedproduct.lawhands_branch?.includes(o.value)
                                                        )}
                                                        onChange={(e) => this.handleChangeselect(e, 'lawhands_branch', 'multiselect')}
                                                    />
                                                }
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-group" style={{ zIndex: "auto" }}>
                                                <label className="col-form-label">Template:<span style={{ color: "red" }}>*</span></label>{" "}
                                                {this.state.bank_templates && this.state.bank_templates.length > 0 && this.state.bank_templates.map((opt: any) => {
                                                    opt.label = opt.name; opt.value = opt.id
                                                }) &&
                                                    <Select className="form-select" options={[{ label: "Select...", value: "" }, ...this.state.bank_templates]} name="temp_id"
                                                        value={this.state.bank_templates.find((o: any) => o.value === this.state.selectedproduct.temp_id)}
                                                        onChange={(e) => this.handleChangeselect(e, 'temp_id', 'singleselect')}
                                                    />
                                                }
                                                {this.state.selectedproduct.temp_id == "" && this.state.required == true && <div className="pt-1" style={{ fontSize: "11px", color: "#dc3545" }}>*Required Field</div>}
                                            </div>
                                        </div>

                                        {Array.isArray(this.state.files) && this.state?.files?.length == 0 &&
                                            <div className="col-md-6">
                                                <label className="col-form-label">Upload Sample Doc:<span style={{ color: "red" }}>*</span></label>
                                                <ReactFileReader
                                                    fileTypes={[".pdf"]}
                                                    base64={true}
                                                    multipleFiles={false}
                                                    handleFiles={this.handleFiles}
                                                >
                                                    <button type="button" className="ml2 btn btn-primary btnupload query-upload p-1 m-0">
                                                        <MdOutlineUploadFile color="white" style={{ height: "30", width: "20px" }} />
                                                        Upload
                                                    </button>
                                                </ReactFileReader>
                                                {this.state.files && this.state.files.length == 0 && this.state.required && <p className="pt-1" style={{ fontSize: "11px", color: "#dc3545" }}>*Required Field</p>}
                                            </div>
                                        }
                                    </div>
                                    <div className="form-group row mt-5">
                                        {Array.isArray(this.state.files) && this.state.files.length > 0 && this.state.files.map((itm: any, index) => (
                                            <div className="col-sm-10" key={index}>
                                                <div className="card card-border-c-green">
                                                    <span
                                                        onClick={() => this.deleteDoc(index)}
                                                    >
                                                        <i className="feather icon-x cursor-pointer" />
                                                    </span>
                                                    <div className="card-body">
                                                        <h5 className="card-title">
                                                            <span className="mb-1 text-c-green">
                                                                <i className="feather icon-file-text" />
                                                            </span>
                                                            <span>
                                                                {itm.fileName || itm.s3fileName}
                                                            </span>
                                                            <span style={{ float: 'right' }}
                                                                className="cursor-pointer"
                                                                data-toggle="modal"
                                                                data-target="#preview-document"
                                                                onClick={() =>
                                                                    this.previewDoc(itm.fileContent)
                                                                }
                                                            >
                                                                <i className="fa fa-eye" />
                                                            </span>
                                                        </h5>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-dismiss="modal"
                                    onClick={this.closeModal}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={this.saveBank}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    className="modal fade"
                    id="delete-bank"
                    role="dialog"
                    aria-hidden="true"
                >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Delete Sample Format</h5>
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <h6>Are you sure you want to delete this Sample Format?</h6>
                                <div className="form-group">
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-dismiss="modal"
                                >
                                    No
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={this.deleteBank}
                                >
                                    Yes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    className="modal fade"
                    id="preview-document"
                    role="dialog"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-lg" role="document"
                        style={{ maxWidth: "1200px" }}
                    >
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Preview</h5>
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <iframe
                                    width="100%"
                                    height="500px"
                                    src={this.state.docToPreview}
                                ></iframe>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-dismiss="modal"
                                    onClick={() => {
                                        this.setState({ docToPreview: "" });
                                    }}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* THIS FOR OUT REASON MODAL */}
                <div className="modal fade hide in" id="out_reason" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog ">
                        <div className="modal-content" style={{ borderRadius: '10px', boxShadow: '0 0 15px #000' }}>
                            <div className="modal-body" style={{ padding: '30px 23px 29px 24px' }}>
                                <h3 style={{ margin: 'auto', fontSize: '17px' }}>Please Select The Reason For To Close The File.No:{localStorage.getItem("currentfileId")}</h3>
                            </div>
                            <div className="form-group" style={{ width: '74%', margin: 'auto' }}>
                                <select
                                    className="custom-select"
                                    name="outreason"
                                    value={this.state.outreason}
                                    onChange={(e) => this.onchangeReason(e)}
                                    required
                                    id="select1"
                                    style={{ marginTop: '8px' }}
                                >
                                    <option value="select">Select Your Reason</option>
                                    <option value="Query Raised">Query Raised</option>
                                    <option value=" Re-Query Raised"> Re-Query Raised</option>
                                    <option value="Hold ">Hold </option>
                                    <option value="Completed">Completed</option>
                                    <option value="Other">Others</option>

                                </select>
                                {this.state.selectVal ? <p style={{ color: 'red', textAlign: 'center', fontSize: '16px' }}>Please Select Your Reason </p> : null}
                            </div>
                            <div className="modal-footer" style={{ marginTop: '27px' }}>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={this.state.isLoading}
                                    onClick={this.outimeGet}
                                    style={{ width: '76px', fontSize: '17px' }}
                                >{this.state.isLoading ? (
                                    <i className="fa fa-spinner fa-spin"></i>
                                ) : "OK"}</button>
                                <button
                                    type="button"
                                    className="btn btn-outline"
                                    onClick={this.BacktoFile}
                                    style={{ width: '107px', fontSize: '14px', border: '1px solid black', height: '43px' }}
                                > Back To File</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* OTHER REASON MODAL */}
                <div className="modal hide fade in" id="another-reason" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog ">
                        <div className="modal-content" style={{ borderRadius: '10px', boxShadow: '0 0 15px #000' }}>
                            <h5 style={{ marginTop: '31px', textAlign: 'center' }}>Please Type a Reason To Close The File.No: {localStorage.getItem("currentfileId")} </h5>
                            <div className="modal-body" style={{ padding: '30px 23px 29px 24px' }}>

                                {/* <div className="col-md-5"> */}
                                <div className="form-group" style={{ width: '98%', margin: 'auto' }}>
                                    <textarea
                                        className="form-control"
                                        placeholder="Type Your Reason"
                                        name="outreason" onChange={this.onchange} />
                                    {this.state.selectVal ? <p style={{ color: 'red', textAlign: 'center', fontSize: '16px' }}>Please Select Your Reason </p> : null}
                                </div>
                                {/* </div> */}

                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={this.state.isLoading}
                                    onClick={() => this.outimeGet()}
                                    style={{ width: '76px', fontSize: '17px' }}
                                > {this.state.isLoading ? (
                                    <i className="fa fa-spinner fa-spin"></i>
                                ) : "OK"}</button>
                                <button
                                    type="button"
                                    className="btn btn-outline"

                                    onClick={() => this.previousPop()}
                                    // onClick={this.disableModalHandler}
                                    style={{ width: '76px', fontSize: '17px', border: '1px solid black' }}
                                > Back</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
export default SampleFormatManagement;
